import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MilitaryTruckIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 3.75982C2 2.50571 2.9563 1.45853 4.20526 1.34498C6.72988 1.11547 9.27012 1.11547 11.7947 1.34498C13.0437 1.45853 14 2.50571 14 3.75982V5.00001H14.5C14.7761 5.00001 15 5.22387 15 5.50001V7.50001C15 7.77615 14.7761 8.00001 14.5 8.00001H14V12.2C14 12.48 14 12.62 13.9455 12.727C13.9015 12.8133 13.8335 12.8848 13.75 12.933V14.2C13.75 14.48 13.75 14.62 13.6955 14.727C13.6476 14.8211 13.5711 14.8976 13.477 14.9455C13.37 15 13.23 15 12.95 15H12.05C11.77 15 11.63 15 11.523 14.9455C11.4289 14.8976 11.3524 14.8211 11.3045 14.727C11.25 14.62 11.25 14.48 11.25 14.2V13H4.75V14.2C4.75 14.48 4.75 14.62 4.6955 14.727C4.64757 14.8211 4.57108 14.8976 4.477 14.9455C4.37004 15 4.23003 15 3.95 15H3.05C2.76997 15 2.62996 15 2.523 14.9455C2.42892 14.8976 2.35243 14.8211 2.3045 14.727C2.25 14.62 2.25 14.48 2.25 14.2V12.933C2.16645 12.8848 2.09846 12.8133 2.0545 12.727C2 12.62 2 12.48 2 12.2V8.00001H1.5C1.22386 8.00001 1 7.77615 1 7.50001L1 5.50001C1 5.22387 1.22386 5.00001 1.5 5.00001H2L2 3.75982ZM4 6C4 5.44772 4.44772 5 5 5H11C11.5523 5 12 5.44772 12 6V7.5C12 7.77614 11.7761 8 11.5 8H4.5C4.22386 8 4 7.77614 4 7.5V6ZM3.75 11.5C4.16421 11.5 4.5 11.1642 4.5 10.75C4.5 10.3358 4.16421 10 3.75 10C3.33579 10 3 10.3358 3 10.75C3 11.1642 3.33579 11.5 3.75 11.5ZM13 10.75C13 11.1642 12.6642 11.5 12.25 11.5C11.8358 11.5 11.5 11.1642 11.5 10.75C11.5 10.3358 11.8358 10 12.25 10C12.6642 10 13 10.3358 13 10.75ZM6.25 10C6.11193 10 6 10.1119 6 10.25V10.75C6 10.8881 6.11193 11 6.25 11H9.75C9.88807 11 10 10.8881 10 10.75V10.25C10 10.1119 9.88807 10 9.75 10H6.25Z"
			></path>
		</svg>
	),
)
